import React from 'react';

import { IconProps } from '../../DefaultIcon';

export function CommercialIcon({ className }: IconProps) {
  return (
    <svg
      width="84"
      height="85"
      viewBox="0 0 84 85"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1580)">
        <path
          d="M80.1771 1.14209H23.6657C21.5592 1.14209 19.8428 2.85507 19.8428 4.95736V81.1848C19.8428 83.2871 21.5592 85.0001 23.6657 85.0001H80.1771C82.2836 85.0001 84 83.2871 84 81.1848V4.95736C84 2.85507 82.2836 1.14209 80.1771 1.14209Z"
          fill="#EAEDF8"
        />
        <path
          d="M75.9902 6.85181H27.8527C27.0205 6.85181 26.3184 7.52662 26.3184 8.3831V73.1907C26.3184 74.0213 26.9945 74.722 27.8527 74.722H75.9642C76.7964 74.722 77.4985 74.0472 77.4985 73.1907V8.3831C77.4985 7.55257 76.8224 6.85181 75.9642 6.85181"
          fill="#D6DCE8"
        />
        <path
          d="M64.1577 12.1985H39.7118C38.2295 12.1985 37.0332 11.0046 37.0332 9.52519V1.14198C37.0332 0.519084 37.5533 0 38.1775 0H65.666C66.2902 0 66.8103 0.519084 66.8103 1.14198V9.52519C66.8103 11.0046 65.614 12.1985 64.1317 12.1985M39.3217 2.28397V9.52519C39.3217 9.73282 39.5038 9.9145 39.7118 9.9145H64.1577C64.3657 9.9145 64.5478 9.73282 64.5478 9.52519V2.28397H39.3478H39.3217Z"
          fill="#00416B"
        />
        <path
          d="M59.5544 19.8289H44.2888C43.6647 19.8289 43.1445 19.3098 43.1445 18.6869C43.1445 18.064 43.6647 17.5449 44.2888 17.5449H59.5544C60.1786 17.5449 60.6987 18.064 60.6987 18.6869C60.6987 19.3098 60.1786 19.8289 59.5544 19.8289Z"
          fill="#00416B"
        />
        <path
          d="M70.633 26.6807H56.8757C56.2516 26.6807 55.7314 26.1616 55.7314 25.5387C55.7314 24.9158 56.2516 24.3967 56.8757 24.3967H70.633C71.2571 24.3967 71.7773 24.9158 71.7773 25.5387C71.7773 26.1616 71.2571 26.6807 70.633 26.6807Z"
          fill="#00416B"
        />
        <path
          d="M51.1539 26.6807H36.0183C35.3941 26.6807 34.874 26.1616 34.874 25.5387C34.874 24.9158 35.3941 24.3967 36.0183 24.3967H51.1539C51.778 24.3967 52.2982 24.9158 52.2982 25.5387C52.2982 26.1616 51.778 26.6807 51.1539 26.6807Z"
          fill="#00416B"
        />
        <path
          d="M70.6329 33.5327H49.6199C48.9957 33.5327 48.4756 33.0137 48.4756 32.3908C48.4756 31.7679 48.9957 31.2488 49.6199 31.2488H70.6329C71.257 31.2488 71.7771 31.7679 71.7771 32.3908C71.7771 33.0137 71.257 33.5327 70.6329 33.5327Z"
          fill="#00416B"
        />
        <path
          d="M44.2883 33.5327H36.0183C35.3941 33.5327 34.874 33.0137 34.874 32.3908C34.874 31.7679 35.3941 31.2488 36.0183 31.2488H44.2883C44.9124 31.2488 45.4325 31.7679 45.4325 32.3908C45.4325 33.0137 44.9124 33.5327 44.2883 33.5327Z"
          fill="#00416B"
        />
        <path
          d="M70.0608 40.4107H36.0447C35.4205 40.4107 34.9004 39.8916 34.9004 39.2687C34.9004 38.6458 35.4205 38.1267 36.0447 38.1267H70.0608C70.6849 38.1267 71.205 38.6458 71.205 39.2687C71.205 39.8916 70.6849 40.4107 70.0608 40.4107Z"
          fill="#00416B"
        />
        <path
          d="M46.9673 47.2625H36.0447C35.4205 47.2625 34.9004 46.7434 34.9004 46.1205C34.9004 45.4976 35.4205 44.9785 36.0447 44.9785H46.9673C47.5914 44.9785 48.1115 45.4976 48.1115 46.1205C48.1115 46.7434 47.5914 47.2625 46.9673 47.2625Z"
          fill="#00416B"
        />
        <path
          d="M50.3997 54.1143H36.0183C35.3941 54.1143 34.874 53.5952 34.874 52.9723C34.874 52.3494 35.3941 51.8303 36.0183 51.8303H50.3997C51.0239 51.8303 51.544 52.3494 51.544 52.9723C51.544 53.5952 51.0239 54.1143 50.3997 54.1143Z"
          fill="#00416B"
        />
        <path
          d="M50.3998 60.9922H33.2097C32.5856 60.9922 32.0654 60.4731 32.0654 59.8502C32.0654 59.2273 32.5856 58.7083 33.2097 58.7083H50.3998C51.0239 58.7083 51.5441 59.2273 51.5441 59.8502C51.5441 60.4731 51.0239 60.9922 50.3998 60.9922Z"
          fill="#00416B"
        />
        <path
          d="M42.754 67.8443H33.2097C32.5856 67.8443 32.0654 67.3252 32.0654 66.7023C32.0654 66.0794 32.5856 65.5603 33.2097 65.5603H42.754C43.3781 65.5603 43.8982 66.0794 43.8982 66.7023C43.8982 67.3252 43.3781 67.8443 42.754 67.8443Z"
          fill="#00416B"
        />
        <path
          d="M29.8811 57.0214H3.64087C1.63839 57.0214 0 55.3863 0 53.3878V17C0 15.0016 1.63839 13.3665 3.64087 13.3665H29.8811C31.8836 13.3665 33.522 15.0016 33.522 17V53.3878C33.522 55.3863 31.8836 57.0214 29.8811 57.0214Z"
          fill="#B0B9CF"
        />
        <path
          d="M28.9712 23.9037H4.55142C4.16132 23.9037 3.82324 23.5923 3.82324 23.177V18.09C3.82324 17.7007 4.16132 17.3633 4.55142 17.3633H28.9712C29.3613 17.3633 29.6994 17.7007 29.6994 18.09V23.177C29.6994 23.5663 29.3613 23.9037 28.9712 23.9037Z"
          fill="#D6DCE8"
        />
        <path
          d="M18.4127 39.3724H21.9496C22.3657 39.3724 22.7038 39.035 22.7038 38.6198V35.09C22.7038 34.6747 22.3657 34.3633 21.9496 34.3633H18.4127C17.9966 34.3633 17.6846 34.7007 17.6846 35.09V38.6198C17.6846 39.035 18.0227 39.3724 18.4127 39.3724Z"
          fill="white"
        />
        <path
          d="M8.26954 34.3633H4.7327C4.3166 34.3633 3.97852 34.7007 3.97852 35.09V38.6198C3.97852 39.035 4.3166 39.3724 4.7327 39.3724H8.26954C8.68564 39.3724 8.99771 39.035 8.99771 38.6198V35.09C8.99771 34.6747 8.65963 34.3633 8.26954 34.3633Z"
          fill="white"
        />
        <path
          d="M15.8639 31.7938V28.2641C15.8639 27.8488 15.5258 27.5374 15.1097 27.5374H11.5729C11.1568 27.5374 10.8447 27.8748 10.8447 28.2641V31.7938C10.8447 32.2091 11.1828 32.5465 11.5729 32.5465H15.1097C15.5258 32.5465 15.8639 32.2091 15.8639 31.7938Z"
          fill="white"
        />
        <path
          d="M8.26954 27.5374H4.7327C4.3166 27.5374 3.97852 27.8748 3.97852 28.2641V31.7938C3.97852 32.2091 4.3166 32.5465 4.7327 32.5465H8.26954C8.68564 32.5465 8.99771 32.2091 8.99771 31.7938V28.2641C8.99771 27.8488 8.65963 27.5374 8.26954 27.5374Z"
          fill="white"
        />
        <path
          d="M15.1097 34.3633H11.5729C11.1568 34.3633 10.8447 34.7007 10.8447 35.09V38.6198C10.8447 39.035 11.1828 39.3724 11.5729 39.3724H15.1097C15.5258 39.3724 15.8639 39.035 15.8639 38.6198V35.09C15.8639 34.6747 15.5258 34.3633 15.1097 34.3633Z"
          fill="white"
        />
        <path
          d="M18.4127 46.1725H21.9496C22.3657 46.1725 22.7038 45.8351 22.7038 45.4458V41.916C22.7038 41.5007 22.3657 41.1633 21.9496 41.1633H18.4127C17.9966 41.1633 17.6846 41.5007 17.6846 41.916V45.4458C17.6846 45.861 18.0227 46.1725 18.4127 46.1725Z"
          fill="white"
        />
        <path
          d="M10.8447 41.916V45.4458C10.8447 45.861 11.1828 46.1725 11.5729 46.1725H15.1097C15.5258 46.1725 15.8639 45.8351 15.8639 45.4458V41.916C15.8639 41.5007 15.5258 41.1633 15.1097 41.1633H11.5729C11.1568 41.1633 10.8447 41.5007 10.8447 41.916Z"
          fill="white"
        />
        <path
          d="M22.7038 31.7938V28.2641C22.7038 27.8488 22.3657 27.5374 21.9496 27.5374H18.4127C17.9966 27.5374 17.6846 27.8748 17.6846 28.2641V31.7938C17.6846 32.2091 18.0227 32.5465 18.4127 32.5465H21.9496C22.3657 32.5465 22.7038 32.2091 22.7038 31.7938Z"
          fill="white"
        />
        <path
          d="M24.5234 52.2459C24.5234 52.6612 24.8615 52.9986 25.2776 52.9986H28.8145C29.2306 52.9986 29.5426 52.6612 29.5426 52.2459V41.9421C29.5426 41.5269 29.2046 41.1895 28.8145 41.1895H25.2776C24.8615 41.1895 24.5234 41.5269 24.5234 41.9421V52.2459Z"
          fill="#00C4B3"
        />
        <path
          d="M25.2522 39.3724H28.7891C29.2052 39.3724 29.5172 39.035 29.5172 38.6198V35.09C29.5172 34.6747 29.1792 34.3633 28.7891 34.3633H25.2522C24.8361 34.3633 24.498 34.7007 24.498 35.09V38.6198C24.498 39.035 24.8361 39.3724 25.2522 39.3724Z"
          fill="white"
        />
        <path
          d="M28.7891 27.5374H25.2522C24.8361 27.5374 24.498 27.8748 24.498 28.2641V31.7938C24.498 32.2091 24.8361 32.5465 25.2522 32.5465H28.7891C29.2052 32.5465 29.5172 32.2091 29.5172 31.7938V28.2641C29.5172 27.8488 29.1792 27.5374 28.7891 27.5374Z"
          fill="white"
        />
        <path
          d="M4.00488 48.7421V52.2719C4.00488 52.6871 4.34296 53.0245 4.75906 53.0245H8.29591C8.712 53.0245 9.02408 52.6871 9.02408 52.2719V48.7421C9.02408 48.3268 8.686 48.0154 8.29591 48.0154H4.75906C4.34296 48.0154 4.00488 48.3528 4.00488 48.7421Z"
          fill="white"
        />
        <path
          d="M8.26954 41.1895H4.7327C4.3166 41.1895 3.97852 41.5269 3.97852 41.9421V45.4719C3.97852 45.8872 4.3166 46.1986 4.7327 46.1986H8.26954C8.68564 46.1986 8.99771 45.8612 8.99771 45.4719V41.9421C8.99771 41.5269 8.65963 41.1895 8.26954 41.1895Z"
          fill="white"
        />
        <path
          d="M10.8447 48.7421V52.2719C10.8447 52.6871 11.1828 53.0245 11.5729 53.0245H15.1097C15.5258 53.0245 15.8639 52.6871 15.8639 52.2719V48.7421C15.8639 48.3268 15.5258 48.0154 15.1097 48.0154H11.5729C11.1568 48.0154 10.8447 48.3528 10.8447 48.7421Z"
          fill="white"
        />
        <path
          d="M17.6846 48.7421V52.2719C17.6846 52.6871 18.0227 53.0245 18.4127 53.0245H21.9496C22.3657 53.0245 22.7038 52.6871 22.7038 52.2719V48.7421C22.7038 48.3268 22.3657 48.0154 21.9496 48.0154H18.4127C17.9966 48.0154 17.6846 48.3528 17.6846 48.7421Z"
          fill="white"
        />
        <path
          d="M69.8007 56.7359L73.1815 58.4229C71.5691 61.2259 68.6564 63.0168 65.0156 63.0168C60.4645 63.0168 57.0837 60.2137 55.8614 56.2168H52.5586L54.223 53.5175H55.4453C55.4193 53.3099 55.4193 53.1542 55.4193 52.9725V52.5313H52.5586L54.223 49.8061H55.8614C57.0057 45.7832 60.4385 42.9282 65.0156 42.9282C68.6564 42.9282 71.5691 44.7191 73.1815 47.5221L69.8007 49.2351C68.8385 47.6519 67.2001 46.6656 65.0156 46.6656C62.597 46.6656 60.8026 47.9114 59.8923 49.8061H69.2286L67.5642 52.5313H59.2422V52.9725C59.2422 53.1542 59.2422 53.3359 59.2682 53.5175H67.3561L65.8738 56.2168H59.9704C60.8806 58.0855 62.623 59.2534 65.0156 59.2534C67.2001 59.2534 68.8385 58.2672 69.8007 56.7099V56.7359Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1580">
          <rect width="84" height="85" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
